export default __webpack_public_path__ + "static/media/peerIcon.c88509a4.png";